<template>
    <v-app id="login" class="login-background">
        <v-container fluid fill-height>
            <v-layout align-center justify-center>
                <v-flex xs3>
                    <v-card>
                        <v-card dark color="primary">
                            <v-card-text>
                                <v-toolbar-title>Login</v-toolbar-title>
                            </v-card-text>
                        </v-card>

                        <!-- <v-flex xs12>
                            <v-layout justify-center class="mt-3">
                                <v-btn-toggle
                                    mandatory
                                    v-model="loginMode"
                                    class="toggle-button-group"
                                >
                                    <v-btn
                                        flat
                                        value="windows"
                                        class="toggle-button"
                                    >
                                        Windows Login
                                    </v-btn>
                                    <v-btn
                                        flat
                                        value="plane"
                                        class="toggle-button"
                                    >
                                        Regular Login
                                    </v-btn>
                                </v-btn-toggle>
                            </v-layout>
                        </v-flex> -->
                        <v-card-text class="pb-2">
                            <v-form>
                                <v-text-field
                                    prepend-icon="mdi-account"
                                    name="login"
                                    label="Login"
                                    type="text"
                                    v-model="username"
                                ></v-text-field>
                                <v-text-field
                                    prepend-icon="mdi-lock"
                                    autocomplete
                                    name="password"
                                    label="Password"
                                    id="password"
                                    type="password"
                                    v-model="password"
                                ></v-text-field>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-layout column>
                                <v-btn
                                    class="mb-3"
                                    dark
                                    :loading="loggingIn"
                                    color="green"
                                    v-on:click="login()"
                                    >Login</v-btn
                                >
                            </v-layout>
                        </v-card-actions>

                        <v-card-text v-if="invalidLogin" class="pt-0">
                            <p class="text-danger">
                                {{ loginError }}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-app>
</template>

<script>
import paths from "../router/paths";

export default {
    data: () => ({
        username: "",
        password: "",
        name: "",
        invalidLogin: false,
        loggingIn: false,
        loginMode: "windows",
        loginError: "",
        pages: [],
    }),
    async created() {
        window.addEventListener("keyup", this.onKeyPressed);

        //await this.$store.dispatch("authentication/AUTH_LOGOUT");
        this.$store.dispatch("AUTH_LOGOUT");

        this.loadPages();
    },
    destroyed() {
        window.removeEventListener("keyup", this.onKeyPressed);
    },
    methods: {
        onKeyPressed(e) {
            if (e.keyCode == 13) {
                this.login();
            }
        },
        loadPages() {
            this.pages = paths;
        },
        async login() {
            this.loginTemp();
            // this.loggingIn = true;

            // this.$Progress.start();

            // try {
            //     const user = await this.$store.dispatch(
            //         "authentication/AUTH_REQUEST",
            //         {
            //             username: this.username,
            //             password: this.password,
            //             windowsLogin: this.loginMode == "windows",
            //         }
            //     );

            //     this.$router.push({
            //         name: this.getRedirectLink(user),
            //         params: this.$route.query.params,
            //     });

            //     this.$Progress.finish();
            // } catch (error) {
            //     this.loggingIn = false;

            //     this.$Progress.finish();

            //     this.invalidLogin = true;
            //     this.loginError = error;
            // }
        },
        async loginTemp() {
            this.loggingIn = true;

            this.$Progress.start();

            try {
                const user = await this.$store.dispatch("AUTH_REQUEST", {
                    username: this.username.trim(),
                    password: this.password.trim(),
                });

                this.$Progress.finish();

                this.$router.push({
                    name: "Accounts",
                });
            } catch (error) {
                this.loggingIn = false;

                this.$Progress.finish();

                this.invalidLogin = true;
                this.loginError = error;
            }
        },
        getRedirectLink(user) {
            if (!user.isAdmin) {
                const page = this.pages.find(
                    (path) =>
                        !path.path.includes(":") &&
                        user.claims.includes(path.name)
                );

                return page ? page.name : user.claims[0];
            }

            return this.$route.query.redirect
                ? this.$route.query.redirect
                : "Accounts";
        },
    },
};
</script>
<style>
.toggle-button {
    font-size: 15px;
    padding: 5px !important;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active {
    background-color: #dcdfe6;
}

.login-background {
    /*background-image: url(https://utaw.blob.core.windows.net/images/logo+uta11.png) !important;

    background-position: right 50% bottom 95% !important;
    background-repeat: no-repeat !important;
    background-size: 10% !important;*/
}
</style>
